import { UserMoodFrequency } from 'user/model/user-mood-frequency';

export interface IUserMetadata {
	readonly moodFrequency: UserMoodFrequency;
	readonly moodDescriptionShown?: boolean;
	readonly registrationTimestamp: number;
	readonly livingAddress: string;
	readonly originAddress: string;
	readonly linkedInUrl: string;
	readonly language: string;
	readonly birthDate: Date;
	readonly cvUrl: string;
	readonly quote: string;
}

export class UserMetadata implements IUserMetadata {
	private _moodFrequency: UserMoodFrequency;
	private _moodDescriptionShown?: boolean;
	private _registrationTimestamp: number;
	private _livingAddress: string;
	private _originAddress: string;
	private _linkedInUrl: string;
	private _language: string;
	private _birthDate: Date;
	private _cvUrl: string;
	private _quote: string;

	constructor(
		moodFrequency?: UserMoodFrequency,
		moodDescriptionShown?: boolean,
		registrationTimestamp?: number,
		livingAddress?: string,
		originAddress?: string,
		linkedInUrl?: string,
		language?: string,
		birthDate?: Date,
		cvUrl?: string,
		quote?: string
	) {
		this._registrationTimestamp = registrationTimestamp;
		this._moodDescriptionShown = moodDescriptionShown;
		this._moodFrequency = moodFrequency;
		this._livingAddress = livingAddress;
		this._originAddress = originAddress;
		this._linkedInUrl = linkedInUrl;
		this._language = language;
		this._birthDate = birthDate;
		this._cvUrl = cvUrl;
		this._quote = quote;
	}

	public get registrationTimestamp(): number {
		return this._registrationTimestamp;
	}

	public get moodDescriptionShown(): boolean {
		return this._moodDescriptionShown;
	}

	public get moodFrequency(): UserMoodFrequency {
		return this._moodFrequency;
	}

	public get livingAddress(): string {
		return this._livingAddress ?? '';
	}

	public get originAddress(): string {
		return this._originAddress ?? '';
	}

	public get linkedInUrl(): string {
		return this._linkedInUrl;
	}

	public get language(): string {
		return this._language;
	}

	public get birthDate(): Date {
		return this._birthDate;
	}

	public get cvUrl(): string {
		return this._cvUrl;
	}

	public get quote(): string {
		return this._quote;
	}

	public updateMoodFrequency(frequency: UserMoodFrequency) {
		this._moodFrequency = frequency;
	}
}
